import { useTranslation } from 'react-i18next';
import { trackMixpanelEvent } from 'utils/analytics';

import { Button, Typography } from '@/shared/components/atoms';
import { useAuth } from '@/shared/hooks/context/auth';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import ArrowDownIcon from '~/images/shared/arrow-down.svg';
import ArrowUpIcon from '~/images/shared/arrow-up.svg';
import ClockIcon from '~/images/shared/clock.svg';
import CopyIcon from '~/images/shared/copy.svg';

function ExpiredPopup() {
  const { user } = useAuth();
  const { t } = useTranslation();
  const { closeModal } = useModal();

  return (
    <div
      className='flex flex-col items-center justify-center gap-16'
      style={{
        maxWidth: '460px',
        width: '100%',
        padding: '36px 24px 24px 24px;',
        backgroundColor: '#FCFCFC',
        border: '#DFE3E8',
        borderRadius: '24px',
      }}
    >
      <div
        style={{
          width: '48px',
          height: '48px',
          backgroundColor: '#F9DEDC',
          padding: '9px',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <ClockIcon
          width={36}
          height={36}
          style={{
            color: '#601410',
          }}
        />
      </div>
      <div className='flex flex-col items-center justify-center'>
        <Typography variant='h2'>{t('popup-trial-ended')}</Typography>
        <Typography variant='h2'>
          {t('subscribe-promo', { saving: '$100' })}
        </Typography>
      </div>

      <div
        className='flex h-[44px] cursor-pointer items-center gap-2 rounded-lg pr-8'
        style={{ border: '1px solid #DFE3E8' }}
        onClick={() => {
          navigator.clipboard.writeText('SAVE100');
        }}
      >
        <Typography variant='h3' className='px-2'>
          SAVE100
        </Typography>
        <div
          style={{
            borderLeft: '1px solid #DFE3E8',
            paddingLeft: '12px',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CopyIcon width={24} height={24} />
        </div>
      </div>
      <Typography
        variant='subtitle2'
        className='text-center'
        style={{ color: '#637589' }}
      >
        {t('apply-code-checkout')}
      </Typography>

      <hr className='my-8 w-full' style={{ color: '#DFE3E8' }} />

      <Typography variant='h3' className='text-center'>
        {t('help-companies')}
      </Typography>
      <div className='flex w-full flex-row gap-1 '>
        <div className='flex flex-col items-center justify-center'>
          <Typography
            variant='subtitle2'
            style={{ fontWeight: '500' }}
            className='flex'
          >
            <ArrowUpIcon width={16} height={12} style={{ color: '#0DAF73' }} />
            20%
          </Typography>
          <Typography
            variant='caption'
            className='text-center'
            style={{ color: '#637589' }}
          >
            {t('efficiency-promo-text')}
          </Typography>
        </div>
        <div className='flex flex-col'>
          <Typography
            variant='subtitle2'
            style={{ fontWeight: '500' }}
            className='flex items-center justify-center'
          >
            <ArrowDownIcon
              width={16}
              height={12}
              style={{ color: '#0DAF73' }}
            />
            60%
          </Typography>
          <Typography
            variant='caption'
            className='text-center'
            style={{ color: '#637589' }}
          >
            {t('automation-promo-text')}
          </Typography>
        </div>
        <div className='flex flex-col'>
          <Typography
            variant='subtitle2'
            style={{ fontWeight: '500' }}
            className='flex items-center justify-center'
          >
            <ArrowDownIcon
              width={16}
              height={12}
              style={{ color: '#0DAF73' }}
            />
            10%
          </Typography>
          <Typography
            variant='caption'
            className='text-center'
            style={{ color: '#637589' }}
          >
            {t('saving-promo-text')}
          </Typography>
        </div>
      </div>
      <div className='mt-24 flex w-full justify-end'>
        <Button
          variant='text'
          onClick={() => {
            closeModal();
            closeModal();
            sessionStorage.setItem('hasSeenExpiredPopup', JSON.stringify(true));
            trackMixpanelEvent('Promo code closed', user);
          }}
        >
          {t('continue-exploring')}
        </Button>
        <Button
          onClick={() => {
            closeModal();
            closeModal();
            sessionStorage.setItem('hasSeenExpiredPopup', JSON.stringify(true));
            setTimeout(() => {
              window.location.href = '/subscription';
            }, 300);
            trackMixpanelEvent('Promo code CTR', user);
          }}
        >
          {t('promo-cta', { saving: '$100' })}
        </Button>
      </div>
    </div>
  );
}

export default ExpiredPopup;
